import { fetchService } from "@/core/services/fetch-service";
import { IServiceTreeModel } from "../models/service-tree";

export default class ApiDocService {
	public getServiceTree(): Promise<IServiceTreeModel> {
		return fetchService.get<IServiceTreeModel>("/API/ServiceTree");
	}
}

export const apiDocService = new ApiDocService();